<script>
    // Importa el componente ProductoView desde su respectiva ubicación
    import ProductoView from "../../viewsERP/Producto.svelte";
</script>

<div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
        <ProductoView />
    </div>
</div>
